(() => {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  const ensurePreviewField = (form) => {
    const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!previewId) return;
    let field = form.querySelector('input[name="preview_theme_id"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'preview_theme_id';
      form.appendChild(field);
    }
    field.value = previewId;
  };

  const submitFacetsForm = (form) => {
    if (!form) return;
    ensurePreviewField(form);
    form.submit();
  };

  const isActiveFacetForm = (form) => {
    if (!form) return false;
    if (form.closest('.collection-facets--drawer')) {
      return window.matchMedia('(max-width: 1024px)').matches;
    }
    if (form.closest('.collection-facets--desktop')) {
      return window.matchMedia('(min-width: 1025px)').matches;
    }
    return true;
  };

  const syncFacetInert = () => {
    const desktop = $('.collection-facets--desktop');
    const drawer = $('.collection-facets-drawer');
    const mobile = window.matchMedia('(max-width: 1024px)').matches;
    desktop?.toggleAttribute('inert', mobile);
    drawer?.toggleAttribute('inert', !mobile);
  };

  const initPriceFacet = (root) => {
    const slider = $('[data-price-slider]', root);
    const minRange = $('[data-range-min]', root);
    const maxRange = $('[data-range-max-input]', root);
    const minHidden = $('[data-price-min]', root);
    const maxHidden = $('[data-price-max]', root);
    const minDisplay = $('[data-price-min-display]', root);
    const maxDisplay = $('[data-price-max-display]', root);
    const fill = $('[data-price-fill]', root);
    if (!slider || !minRange || !maxRange || !minHidden || !maxHidden || !minDisplay || !maxDisplay) return;

    const rangeMin = Number(root.dataset.rangeMinCents || minRange.min || 0) || 0;
    const rangeMax = Number(root.dataset.rangeMaxCents || maxRange.max || 0) || 0;
    if (rangeMax <= 0) return;

    let debounce;

    const clamp = (floor, val, ceiling) => Math.min(Math.max(val, floor), ceiling);

    const formatAmount = (cents) => {
      if (window.Shopify?.formatMoneyAmount) return window.Shopify.formatMoneyAmount(cents);
      return (cents / 100).toFixed(2);
    };

    const parseMajorInput = (raw) => {
      const cleaned = String(raw || '')
        .replace(/[^\d.,\u0660-\u0669]/g, '')
        .replace(/[\u0660-\u0669]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
        .replace(/,/g, '.');
      const parts = cleaned.split('.');
      const normalized = parts.length > 2 ? `${parts.shift()}.${parts.join('')}` : cleaned;
      const major = parseFloat(normalized);
      if (!Number.isFinite(major) || major < 0) return 0;
      return Math.round(major * 100);
    };

    const syncFill = () => {
      if (!fill) return;
      const span = rangeMax - rangeMin || 1;
      const lo = ((Number(minRange.value) - rangeMin) / span) * 100;
      const hi = ((Number(maxRange.value) - rangeMin) / span) * 100;
      fill.style.insetInlineStart = `${lo}%`;
      fill.style.insetInlineEnd = `${100 - hi}%`;
    };

    const syncHiddenFromRanges = () => {
      const minCents = Number(minRange.value);
      const maxCents = Number(maxRange.value);
      minHidden.value = minCents > rangeMin ? String(minCents) : '';
      maxHidden.value = maxCents < rangeMax ? String(maxCents) : '';
    };

    const syncDisplaysFromRanges = () => {
      const minCents = Number(minRange.value);
      const maxCents = Number(maxRange.value);
      minDisplay.value = minCents > rangeMin ? formatAmount(minCents) : '';
      maxDisplay.value = maxCents < rangeMax ? formatAmount(maxCents) : '';
      if (!maxDisplay.value) maxDisplay.placeholder = formatAmount(rangeMax);
      syncHiddenFromRanges();
      syncFill();
    };

    const syncRangesFromDisplays = () => {
      let minCents = parseMajorInput(minDisplay.value);
      let maxCents = parseMajorInput(maxDisplay.value || formatAmount(rangeMax));
      minCents = clamp(rangeMin, minCents, rangeMax);
      maxCents = clamp(rangeMin, maxCents, rangeMax);
      if (minCents > maxCents) {
        if (document.activeElement === minDisplay) maxCents = minCents;
        else minCents = maxCents;
      }
      minRange.value = minCents;
      maxRange.value = maxCents;
      syncDisplaysFromRanges();
    };

    const applyPriceFieldNames = () => {
      const minCents = Number(minHidden.value || 0);
      const maxCents = Number(maxHidden.value || rangeMax);
      const minName = minHidden.dataset.paramName;
      const maxName = maxHidden.dataset.paramName;

      if (minName) {
        if (minHidden.value !== '' && minCents > rangeMin) minHidden.setAttribute('name', minName);
        else minHidden.removeAttribute('name');
      }
      if (maxName) {
        if (maxHidden.value !== '' && maxCents < rangeMax) maxHidden.setAttribute('name', maxName);
        else maxHidden.removeAttribute('name');
      }
    };

    const submitDebounced = () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        syncHiddenFromRanges();
        applyPriceFieldNames();
        const form = root.closest('form');
        if (isActiveFacetForm(form)) submitFacetsForm(form);
      }, 450);
    };

    minRange.addEventListener('input', () => {
      minRange.style.zIndex = '4';
      maxRange.style.zIndex = '3';
      let minCents = Number(minRange.value);
      let maxCents = Number(maxRange.value);
      if (minCents > maxCents) {
        if (document.activeElement === minRange) maxCents = minCents;
        else minCents = maxCents;
      }
      minRange.value = minCents;
      maxRange.value = maxCents;
      syncDisplaysFromRanges();
    });
    maxRange.addEventListener('input', () => {
      maxRange.style.zIndex = '4';
      minRange.style.zIndex = '3';
      let minCents = Number(minRange.value);
      let maxCents = Number(maxRange.value);
      if (minCents > maxCents) {
        if (document.activeElement === maxRange) minCents = maxCents;
        else maxCents = minCents;
      }
      minRange.value = minCents;
      maxRange.value = maxCents;
      syncDisplaysFromRanges();
    });
    minRange.addEventListener('change', submitDebounced);
    maxRange.addEventListener('change', submitDebounced);

    minDisplay.addEventListener('change', () => {
      syncRangesFromDisplays();
      submitDebounced();
    });
    maxDisplay.addEventListener('change', () => {
      syncRangesFromDisplays();
      submitDebounced();
    });

    let minCents = Number(root.dataset.currentMinCents || rangeMin);
    let maxCents = Number(root.dataset.currentMaxCents || rangeMax);
    minCents = clamp(rangeMin, minCents, rangeMax);
    maxCents = clamp(rangeMin, maxCents, rangeMax);
    if (minCents > maxCents) maxCents = minCents;
    minRange.value = minCents;
    maxRange.value = maxCents;
    syncDisplaysFromRanges();
    applyPriceFieldNames();
  };

  const scheduleFacetSubmit = (form) => {
    let debounce;
    return () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        if (isActiveFacetForm(form)) submitFacetsForm(form);
      }, 150);
    };
  };

  const initFacetForm = (form) => {
    if (!form || form.dataset.facetsBound === 'true') return;
    form.dataset.facetsBound = 'true';

    $$('[data-price-facet]', form).forEach(initPriceFacet);

    const submit = scheduleFacetSubmit(form);

    form.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || !form.contains(t)) return;
      if (t.matches('input[type="checkbox"], input[type="radio"]')) {
        submit();
      }
    });

    form.addEventListener('click', (e) => {
      const input = e.target.closest('input[type="checkbox"], input[type="radio"]');
      if (!input || !form.contains(input) || input.disabled) return;
      queueMicrotask(submit);
    });
  };

  const initFacetForms = () => {
    $$('[data-collection-facets]').forEach(initFacetForm);
    syncFacetInert();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacetForms);
  } else {
    initFacetForms();
  }

  window.addEventListener('resize', syncFacetInert, { passive: true });
})();
